<template>
  <tr>
    <template
      v-for="(item, index) in (getHeaders.length)">
      <td
        :key="`registro-${index}`"
        class="selected font-weight-bold"
        align="right">
        <template
          v-if="headers[item - 1].seSuma">
          {{ sumarColuma(headers[item -1].value) | currency }}
        </template>
      </td>
    </template>
  </tr>
</template>

<script>
export default {
  name: 'TableFooterSumaTotales',
  props: {
    registros: {
      type: Array,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    sumarColuma(columna) {
      return this.$ObjSumar(this.registros, columna);
    },
  },
  computed: {
    getHeaders() {
      return this.headers.map((header) => {
        if (!header.seSuma) {
          return {
            ...header,
            seSuma: false,
          };
        }

        return header;
      });
    },
  },
};
</script>

<style lang="scss">

</style>
